import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cogsworthLogo from 'assets/images/cogs-logo.svg'
import upvioLogo from 'assets/images/upvio-logo.svg'
import { ApiConfigContext } from '../../context/api-config'

// Ensures http is at the start of the URL
const appendHttp = (url) => {
  if (!/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  return url
}

export default class BusinessLogo extends Component {

  static contextType = ApiConfigContext

  static propTypes = {
    business: PropTypes.object.isRequired,
    features: PropTypes.object.isRequired,
    position: PropTypes.string
  }


  renderLogo(business, features) {

    // get branding label for logo
    const {brand} = this.context;
    const brandLogo = (brand === 'cogsworth') ? cogsworthLogo : upvioLogo;

    if (features.customLogo) {
      return (
        <a className="business-logo"
          target="_blank" rel="noopener noreferrer"
          href={(business.website && business.logo) ? appendHttp(business.website) : '#'}
          style={{ backgroundImage: `url(${business.logo ? encodeURI(business.logo.url) : brandLogo})` }}
        >&nbsp;</a>
      )
    } else {
      return (
        <a className="business-logo"
          target="_blank" rel="noopener noreferrer"
          href={`https://www.cogsworth.com/?utm_source=booking&utm_campaign=${business.user.id}`}
          style={{ backgroundImage: `url(${brandLogo})` }}
        >&nbsp;</a>
      )
    }
  }

  render() {
    const { business, features, position } = this.props

    if (position === 'HEADER_START' && business.logoPosition === 'TOP-LEFT') {
      return this.renderLogo(business, features)
    }

    if (position === 'FOOTER_START' && business.logoPosition === 'BOTTOM-LEFT') {
      return this.renderLogo(business, features)
    }

    if (position === 'FOOTER_END' && (!business.logoPosition || business.logoPosition === 'BOTTOM-RIGHT')) {
      return this.renderLogo(business, features)
    }

    return null
  }
}
